/* eslint-disable no-lone-blocks */
import React, { useState, useEffect } from "react";
import { Col, Container, Row, Breadcrumb } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import { useLocation } from "react-router-dom";
import PubSub from "pubsub-js";
import Select from "react-select";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import { validationMessages } from "../../utils/messages";
import { regExPattern } from "../../utils/regExPattern";
import { ROUTES } from "../../constants/WebRouting";
// Define initial errors i.e. required field and their message
const initialErrors = {
  product_name: { message: validationMessages.productName.required },
};
const ProductEdit = (props) => {
  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState(location?.state ? location?.state : {});
  const [productCategoryArray, setProductCategoryArray] = useState(
    JSON.parse(localStorage.getItem("product_category"))
  );
  const [optionCategory, setOptionCategory] = useState({});
  const [selectedCategory, setSelectedCategory] = useState();
  const [optionSubCategory, setOptionSubCategory] = useState({});
  const [selectedSubCategory, setSelectedSubCategory] = useState();


  const [producSubcategoryArray, setProductSubcategoryArray] = useState(
    JSON.parse(localStorage.getItem("product_subcategory"))
  );
  const [source, setSource] = useState(product.source || "");

  const productCategory = productCategoryArray;
  const productSubcategory = producSubcategoryArray;
  const [files, setFiles] = useState([]);
  const { category_id, ...rest } = product;

  //errors state
  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  useEffect(() => { console.log('errors', errors) }, [errors])

  useEffect(() => {
    console.log("product", product);
    if (product?.id) {
      // fetchAndSetSubCategories(product?.category_id);
      setSelectedSubCategory({ value: product?.sub_category_id, label: product?.sub_category_name, });
      let temp = {};
    }
    if (location?.state?.productCategory) {
      let prodCategory = productCategory.filter(
        (status) => status.value === location.state.productCategory
      );
    }

    async function init() {
      // subCategory(location?.state?.category_id);
      const fetchCategories = await trasportApi.fetchAllCategory();
      if (fetchCategories) {
        let categoryOptions = fetchCategories.map((item) => ({
          value: item.id,
          label: item.name,
          category: item,
        }));

        setOptionCategory(categoryOptions);
        if (location?.state?.category_id) {
          let category = categoryOptions?.filter(
            (category) => category?.value === location?.state?.category_id
          );
          setSelectedCategory(category);
        }
      } else {
        setOptionCategory([]);
      }
    }
    init();
  }, []);




  // async function fetchAndSetSubCategories(categoryId) {
  //   let fetchSubCategories = await trasportApi.fetchSubCategoryByParentId(categoryId);
  //   // Normalize to array
  //   if (fetchSubCategories) {
  //     if (!Array.isArray(fetchSubCategories)) {
  //       fetchSubCategories = [fetchSubCategories];
  //     }
  //     const categoryOptions = Array.isArray(fetchSubCategories)
  //       ? fetchSubCategories?.map((item) => ({
  //         value: item?.id,
  //         label: item?.sub_category_name,
  //         subcategory: item,
  //       }))
  //       : [];

  //     setOptionSubCategory(categoryOptions);

  //     if (location?.state?.sub_category_id) {
  //       const subcategory = categoryOptions?.filter(
  //         (subcategory) => subcategory?.value === location?.state.sub_category_id
  //       );
  //       setSelectedSubCategory(subcategory ? subcategory : []);
  //     }
  //   } else {
  //     setOptionSubCategory([]);
  //   }
  // }

  const handleChange = (e) => {

    const { name, value } = e.target;
    console.log("name == ", name)

    if (name == "product_name") {
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.productName.required } }));
        setSelectedCategory("")
        setSelectedSubCategory("")
        delete product.category_id
        delete product.sub_category_id
        setProduct({ ...product, sku: "" })
      } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.productName.invalid } }));
      } else {
        setErrors((prev) => {
          console.log("setError delete == ", name)
          console.log("setError prev[name] == ", prev[name])


          delete prev[name];
          return { ...prev };
        });
      }
    }
    setValidated(true);
    const updatedVales = value.toUpperCase()
    setProduct((prev) => ({ ...prev, [name]: updatedVales }));

  };

  const checkRequredFields = () => {
    console.log("product data == ", product)
    let isError = false;
    if (product.product_name) {
      if (product?.product_name == "") {
        setErrors((prev) => ({ ...prev, 'product_name': { message: "Please provide a Product name." } }));
        isError = true;
      } else if (regExPattern?.name && (!RegExp(regExPattern.name).test(product.product_name))) {
        setErrors((prev) => ({ ...prev, 'product_name': { message: "Please provide Valid Product name." } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['product_name'];
          return { ...prev };
        });
      }
    }

    if (product.category_id) {
      if (product?.category_id == "") {
        setErrors((prev) => ({ ...prev, 'category_name': { message: "Please provide a category name." } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['category_name'];
          return { ...prev };
        });
      }
    }
   
    // handle errors for required fields
    if (!product.category_id) {
      console.log("in not")
      setErrors((prev) => ({ ...prev, 'category_name': { message: validationMessages.categoryName.required } }));
      isError = true;
    }
  
    if (!product.product_name) {
      setErrors((prev) => ({ ...prev, 'product_name': { message: validationMessages.productName.required } }));
      isError = true;
    }
    return isError;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Added validation by Shivani mehra starts
    if (checkRequredFields()) {
      console.log("checkRequredFields true")
      setValidated(true);
      return;
    }
    // Added validation by Shivani mehra ends
    //========= Logic to perform Create or Edit ======
    let result = {};
    if (product.id) {
      result = await trasportApi.saveProduct(product);
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Updated",
          message: "Record updated successfully",
        });
        navigate(`/products/${product.id}`, { state: product });
      }
    } else {
      result = await trasportApi.createProduct(product);
      if (result != null) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Created",
          message: "Record created successfully",
        });
        console.log('first create', product);
        navigate(`/products/${result.id}`, { state: product });
      }
    }
  };

  const handleCancel = () => {
    if (product.id) {
      navigate("/products/" + product.id, { state: product });
    } else {
      navigate(`/products`);
    }
  };

  //Category Handler Change
  const handleCategory = (e) => {
    const name = "category_name"; // set manually since react-select doesn't give this
    const value = e?.value;

    setSelectedSubCategory([])
    if (name === "category_name") {
      if (value == "") {
        console.log("in if")
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.categoryName.required } }));
      } else {
        console.log("in else")
        setErrors((prev) => {
          console.log("handleCategory else in name == ", name)
          console.log("handleCategory else in prev[name] == ", prev[name])
          delete prev[name];
          return { ...prev };
        });
      }
    }
    console.log("in out ==", e)
    setValidated(true);
    setSelectedCategory(e);

    setErrors((prev) => ({ ...prev, 'sub_category_name': { message: "Please provide a sub category name" } }));
    delete product.sub_category_id
    delete product.sub_category_name
    //Added By Farhan Khan on 02-March-2025 Using for Generate SKU using product name and category label
    // const generatedSKU = product.product_name
    //   ? `${product.product_name}-${e.label}`.replace(/\s+/g, "-").toUpperCase()
    //   : "";

    const generatedSKU =
      product.product_name && e.label
        ? `${product.product_name.slice(0, 3)}-${e.label
          .split(" ")
          .filter(Boolean)
          .map((word) => word.slice(0, 3))
          .join("-")}`.toUpperCase()
        : "";

    if (!product.id) {
      console.log("State if =>", product);
      setProduct({
        ...product,
        category_id: e.value,
        sku: generatedSKU,
      });
    } else {
      console.log("State else =>", product);
      setProduct({ ...product, category_id: e.value, sku: generatedSKU });
    }
  };
  // Sub Category Handler Change
  const handleSubCategory = (e) => {
    const name = "sub_category_name"; // set manually since react-select doesn't give this
    const value = e?.value;
    if (name === "sub_category_name") {
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.subCategoryName.required } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    setValidated(true);
    setSelectedSubCategory(e);


    //Added By Farhan Khan on 02-March-2025 Using for Generate SKU using product name and category label
    // const generatedSKU = product.product_name
    //   ? `${product.product_name}-${e.label}`.replace(/\s+/g, "-").toUpperCase()
    //   : "";



    if (!product?.id) {
      console.log("State =>", product);
      setProduct({
        ...product,
        sub_category_id: e.value,
      });
    } else {
      setProduct({ ...product, sub_category_id: e.value });
    }
  };

  //File Upload Handle
  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    setFiles(selectedFiles);
    console.log("Selected Files:", selectedFiles);
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ProductEdit}</title>
        </Helmet>
      </>
      <Container className="view-form" fluid>
        <Row>
          <Col></Col>
          <Col lg={8} className="pb-1 pt-2">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => navigate(ROUTES.PRODUCT.LIST)} >Product</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col></Col>
        </Row>
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header">
                <Col lg={8}>
                  {product.id ? <h5>Edit Product</h5> : <h5>Create Product</h5>}
                </Col>
                <Col lg={4} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2 btn-save" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm btn-delete"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>

              <Row className="ibs-edit-form pb-3 ">
                <Row lg={12}>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Product Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="product_name"
                        pattern={regExPattern.name}
                        placeholder="Enter Product Name"
                        value={product.product_name}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.product_name?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Brand Name (Company)
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="brand_name"
                        pattern={regExPattern.name}
                        placeholder="Enter Product Brand Name"
                        value={product.brand_name}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please provide Brand Name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {console.log("sh errors == ", errors)}
                  {console.log("selectedSubCategory == ", selectedSubCategory)}
                  <Col lg={6} className="mt-2">
                    <Form.Group className="mx-3" >
                      <Form.Label
                        className="form-view-label mt-2"
                        htmlFor="formBasicFirstName"
                      >
                        Category Name
                      </Form.Label>
                      <Select
                        required
                        className={product.category_id ? 'custom-select-valid' : 'custom-select-invalid'}
                        placeholder="Select Category"
                        onChange={handleCategory}
                        options={optionCategory}
                        value={selectedCategory}
                        isDisabled={!product.product_name}
                      ></Select>
                      {(errors?.category_name?.message && (!product.category_name)) && product.product_name && <div className="feedback-invalid">
                        {errors?.category_name?.message}
                      </div>}
                    </Form.Group>
                  </Col>
                  {/* {console.log("select Sub Category Name == ",selectedSubCategory)} */}
                  {/* {selectedCategory &&
                    <Col lg={6} className="mt-2">
                      <Form.Group className="mx-3" >
                        <Form.Label
                          className="form-view-label mt-2"
                          htmlFor="formBasicFirstName"
                        >
                          Sub Category Name
                        </Form.Label>
                        <Select
                          required
                          className={product.sub_category_id ? 'custom-select-valid' : 'custom-select-invalid'}
                          placeholder="Select Sub  Category"
                          onChange={handleSubCategory}
                          options={optionSubCategory}
                          value={product.sub_category_id ? selectedSubCategory : ''}
                        ></Select>
                        {(errors?.sub_category_name?.message && (!product.sub_category_name)) && <div className="feedback-invalid">
                          {errors?.sub_category_name?.message}
                        </div>}
                      </Form.Group>
                    </Col>
                  }

                  {console.log("errors message == ",errors?.sub_category_name?.message)}
                  {console.log("errors sub_category_name == ",product.sub_category_name)}
                  {console.log("errors sub_category_name == ",!product.sub_category_name)} */}

                  <Col lg={6}>
                    <Form.Group className="mx-4" >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicTitle"
                      >
                        SKU
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="sku"
                        placeholder="Product SKU"
                        disabled
                        value={product.sku}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group className="mx-3" >
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicLastName"
                      >
                        Remark
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        name="product_description"
                        placeholder="Enter Product Remark"
                        value={product.product_description}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};

export default ProductEdit;
